const ControlBinders = (() => {
    const a = [];
    let hasRunAgainstDocument = false;

    const runWrapper = (scope, wrapper) => {
        if (Array.isArray(scope)) {
            scope.forEach(item => {
                item.querySelectorAll(wrapper.selector).forEach(elm => wrapper.bind(elm));
            });
        } else {
            scope.querySelectorAll(wrapper.selector).forEach(elm => wrapper.bind(elm));
        }
    }

    const register = (selector, binder) => {
        const wrapper = {selector: selector, bind: binder};

        a.push(wrapper);

        if (hasRunAgainstDocument) {
            runWrapper(document, wrapper);
        }
    }

    const run = (scope = document) => {
        a.forEach(wrapper => runWrapper(scope, wrapper));

        if (scope === document) {
            hasRunAgainstDocument = true;
        }
    }

    return {
        register,
        run
    };
})();

ControlBinders.run();